import { format } from "date-fns";
import IWorkOrderStatusViewModel from "interfaces/IWorkOrderStatusViewModel";

const LastUpdatedTemplate = (props: IWorkOrderStatusViewModel): any => {
  const workOrder = { ...props };
  if (!workOrder.lastUpdatedTimestamp) {
    return <></>;
  }

  return (
    <>
      <span className="fw-bold">
        {format(workOrder.lastUpdatedTimestamp, "dd MMM yyyy")}
      </span>
      <br />
      <span>
        {format(workOrder.lastUpdatedTimestamp, "HH:mm")}
      </span>
    </>
  );
};
export default LastUpdatedTemplate;
